import { render, staticRenderFns } from "./FreqSeg.vue?vue&type=template&id=39a4341a&"
import script from "./FreqSeg.vue?vue&type=script&lang=js&"
export * from "./FreqSeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports